// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';
import { MachineListComponent } from './machine-list/machine-list.component';
import { RegisterMachineComponent } from './register-machine/register-machine.component';

// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatFormFieldModule,
	MatSnackBarModule,
	MatTooltipModule,
	MatChip,
	MatChipsModule,
	MatDivider,
	MatDividerModule,
	MatStepperModule,
	MatListModule,
	MatSlideToggleModule
} from '@angular/material';
import { ClientDialogComponent } from '../../core/_components/client-dialog/client-dialog.component';
import { InventoryComponent } from './pro-reports/inventory/inventory.component';
import { NgxPivotTableModule } from 'ngx-pivot-table';
import { ProReportsComponent } from './pro-reports/pro-reports.component';
import { PivotWrapperComponent } from './pro-reports/pivot-wrapper/pivot-wrapper.component';
import { BulkActionsComponent } from './bulk-actions/bulk-actions.component';
import { SwUpdateComponent } from './bulk-actions/sw-update/sw-update.component';
import { MachineCategoryComponent } from './bulk-actions/machine-category/machine-category.component';
import { VersionComponent } from './pro-reports/version/version.component';
import { SubsConfirmationComponent } from './subs-confirmation/subs-confirmation.component';
import { HelpFeedbackComponent } from './help-feedback/help-feedback.component';
import { AddRemarksDialogComponent } from './help-feedback/add-remarks-dialog/add-remarks-dialog.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { StockoutsTabComponent } from './analytics/tabs/stockouts-tab/stockouts-tab.component';
import { DrinkVolumeTabComponent } from './analytics/tabs/drink-volume-tab/drink-volume-tab.component';
import { ConsumptionTabComponent } from './analytics/tabs/consumption-tab/consumption-tab.component';
import { ForecastTabComponent } from './analytics/tabs/forecast-tab/forecast-tab.component';
import { ChartsModule } from 'ng2-charts';

@NgModule({
	declarations: [MachineListComponent, RegisterMachineComponent, ClientDialogComponent,
		InventoryComponent, ProReportsComponent, PivotWrapperComponent, BulkActionsComponent,
		SwUpdateComponent, MachineCategoryComponent, VersionComponent, SubsConfirmationComponent, HelpFeedbackComponent, AddRemarksDialogComponent, AnalyticsComponent, StockoutsTabComponent, DrinkVolumeTabComponent, ConsumptionTabComponent, ForecastTabComponent],
	entryComponents: [ClientDialogComponent, AddRemarksDialogComponent],
	exports: [],
	imports: [
		CommonModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		CoreModule,
		PartialsModule,
		MatDialogModule,
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatChipsModule,
		MatDividerModule,
		MatDatepickerModule,
        MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatStepperModule,
		MatNativeDateModule,
		MatFormFieldModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatListModule,
		MatSlideToggleModule,
		NgxPivotTableModule,
		ChartsModule
	],
	providers: []
})
export class PagesModule {
}
